var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.main }, [
    _c(
      "div",
      { class: _vm.$style.mainHeader },
      [
        _c("MobileIconButton", {
          class: _vm.$style.userButton,
          attrs: {
            symbol: "account-icon",
            "icon-size": "24",
            "icon-fill": "#808080"
          },
          on: { click: _vm.userButtonAction }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("img", {
          class: _vm.$style.mainLogo,
          attrs: {
            srcset:
              require("@/assets/img/LOGO@2x.png") +
              ", " +
              require("@/assets/img/LOGO.png"),
            src: require("@/assets/img/LOGO.png"),
            alt: "Burger Boss"
          }
        }),
        _vm._v(" "),
        _vm.user
          ? _c("p", { class: _vm.$style.welcomText }, [
              _vm._v(
                "\n      Welcome Back, " +
                  _vm._s(_vm._f("capitalize")(_vm.user.firstName)) +
                  "!\n    "
              )
            ])
          : [
              _c("hr", { class: _vm.$style.hr }),
              _vm._v(" "),
              _c(
                "p",
                { class: _vm.$style.text },
                [
                  _vm._v(
                    "\n        Entered a phone number\n        at one of our kiosks?\n\n        "
                  ),
                  _c(
                    "router-link",
                    {
                      class: _vm.$style.link,
                      attrs: { to: { name: "claim-account" } }
                    },
                    [_vm._v("\n          Claim Your Account\n        ")]
                  )
                ],
                1
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.btnGroup },
      [
        _c(
          "MobileButton",
          {
            nativeOn: {
              click: function($event) {
                return _vm.newOrder($event)
              }
            }
          },
          [_vm._v("\n      New Order\n    ")]
        ),
        _vm._v(" "),
        _c(
          "MobileButton",
          {
            attrs: {
              disabled: !_vm.user,
              to: { name: "past-order-select-location" }
            }
          },
          [
            _vm._v("\n      Past Orders\n      "),
            _c("template", { slot: "sub" }, [
              _vm._v("\n        Quickly Re-Order\n      ")
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "MobileButton",
          {
            attrs: { "btn-style": "border" },
            nativeOn: {
              click: function($event) {
                return _vm.goToLocations($event)
              }
            }
          },
          [_vm._v("\n      Locations\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.user
      ? _c("div", { class: _vm.$style.tryOur }, [
          _c("div", { class: _vm.$style.tryOurContent }, [
            _c("h5", { class: _vm.$style.tryOurTitle }, [
              _vm._v("\n        Try Our\n      ")
            ]),
            _vm._v(" "),
            _c("p", { class: _vm.$style.tryOurText }, [
              _vm._v("\n        Vegan black bean patty\n      ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileMain.vue?vue&type=template&id=1f82747b&
// module id = null
// module chunks = 